const behavior = require('../utils/behavior');
const select = require('../utils/select');
const toggle = require('../utils/toggle');
const FocusTrap = require('../utils/focus-trap');
const { CLICK } = require('../events');
const { prefix: PREFIX } = require('../config');

const DIALOG = `.${PREFIX}-dialog`;
const OVERLAY = `.${PREFIX}-dialog-overlay`;
const BUTTON_OPEN = `.${PREFIX}-dialog__open[aria-controls]`;
const BUTTON_CLOSE = `.${PREFIX}-dialog__close`;
const ACTIVE_CLASS = `${PREFIX}-js-dialog--active`;
const VISIBLE_CLASS = 'is-visible';

const getControl = el => document.getElementById(el.getAttribute('aria-controls'));
const isExpanded = el => el.getAttribute('aria-expanded') === 'true';

const toggleVisible = (el, isVisible) => {
  select(OVERLAY).concat(el).forEach(el => el.classList.toggle(VISIBLE_CLASS, isVisible));
  document.body.classList.toggle(ACTIVE_CLASS, isVisible);
}

const show = (dialog, opener) => {
  toggleVisible(dialog, true);
  dialog.focusTrap.update(true);
  dialog.opener = opener;
}

const hide = (dialog) => {
  dialog.focusTrap.update(false);
  if (dialog.opener) {
    dialog.opener.focus();
    toggle(dialog.opener, false);
  }
  toggleVisible(dialog, false);
}

module.exports = behavior(
  {
    [CLICK]: {
      [BUTTON_OPEN]() {
        toggle(this, true);
        show(getControl(this), this);
      },
      [BUTTON_CLOSE]() {
        hide(this.closest(DIALOG));
      },
      [OVERLAY]() {
        select(`${DIALOG}.${VISIBLE_CLASS}`).forEach(hide);
      }
    }
  },
  {
    init (root) {
      select(DIALOG).forEach(dialog => {
        dialog.focusTrap = FocusTrap(dialog, {
          Escape () { hide(dialog); }
        })
      })
      select(BUTTON_OPEN).forEach(button => {
        if (isExpanded(button)) {
          show(getControl(button), button);
        }
      })
    },
    DIALOG,
    OVERLAY,
    BUTTON_CLOSE,
    BUTTON_OPEN,
    hide,
    show,
  }
);